import { createClient } from "@/apollo/clientUtils";
import { createHttpLink } from "apollo-link-http";

const dataSourceLink = createHttpLink({
  uri: "/menu-system/private/data"
});

export const menu = createClient(dataSourceLink);
